"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchFacets = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _recompose = require("@hypnosphi/recompose");

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _reactIntl = require("react-intl");

var _enhancers = require("../enhancers");

var _FacetDetailField = _interopRequireDefault(require("../FacetDetailField"));

var _withStyles = _interopRequireDefault(require("./withStyles"));

var _enhancers2 = require("./enhancers");

var _SearchButton = _interopRequireDefault(require("./SearchButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SearchFacets = function SearchFacets(_ref) {
  var classes = _ref.classes,
      intl = _ref.intl,
      className = _ref.className,
      facets = _ref.facets,
      genericSearchValue = _ref.genericSearchValue,
      handleGenericSearchValueChange = _ref.handleGenericSearchValueChange,
      hideDetailsMenu = _ref.hideDetailsMenu,
      _ref$hideSearch = _ref.hideSearch,
      hideSearch = _ref$hideSearch === void 0 ? false : _ref$hideSearch,
      qeIdTag = _ref.qeIdTag,
      setSearchCriteria = _ref.setSearchCriteria;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, className)
  }, !hideSearch && /*#__PURE__*/_react["default"].createElement(_FacetDetailField["default"], {
    label: intl.formatMessage({
      id: 'search.hasWords'
    }),
    className: classes.facetContainer
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    "data-qe-id": "".concat(qeIdTag, "_HasWords"),
    inputProps: {
      'aria-label': intl.formatMessage({
        id: 'search.hasWords'
      })
    },
    fullWidth: true,
    className: classes.genericInput,
    value: genericSearchValue,
    onChange: handleGenericSearchValueChange
  })), (0, _enhancers.useContextualFacets)(facets).map(function (_ref2) {
    var tag = _ref2.tag,
        shortTag = _ref2.shortTag,
        options = _ref2.options,
        selected = _ref2.selected,
        setSelected = _ref2.setSelected,
        DetailsControl = _ref2.DetailsControl,
        context = _ref2.context,
        facetDetailsContainerStylesOverride = _ref2.facetDetailsContainerStylesOverride;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-qe-id": "".concat(qeIdTag, "_").concat(shortTag),
      key: tag,
      className: classes.facetContainer,
      style: facetDetailsContainerStylesOverride
    }, /*#__PURE__*/_react["default"].createElement(DetailsControl, {
      options: options,
      selected: selected,
      setSelected: setSelected,
      context: context
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.buttonRow
  }, /*#__PURE__*/_react["default"].createElement(_SearchButton["default"], {
    qeIdTag: qeIdTag,
    genericSearchValue: genericSearchValue,
    facets: facets,
    setSearchCriteria: setSearchCriteria,
    hideDetailsMenu: hideDetailsMenu
  })));
};

exports.SearchFacets = SearchFacets;
SearchFacets.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  intl: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  qeIdTag: _propTypes["default"].string,
  facets: _propTypes["default"].array.isRequired,
  genericSearchValue: _propTypes["default"].string,
  handleGenericSearchValueChange: _propTypes["default"].func,
  hideDetailsMenu: _propTypes["default"].func,
  hideSearch: _propTypes["default"].bool,
  setSearchCriteria: _propTypes["default"].func.isRequired
};

var _default = (0, _recompose.compose)((0, _recompose.setDisplayName)('compose(SearchFacets)'), _reactIntl.injectIntl, _enhancers2.withGenericSearchInputHandler, _withStyles["default"])(SearchFacets);

exports["default"] = _default;